import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { LINKTYPES, SnackbarType } from '../app-model/enums';
import { RoutingEventService } from '../../services/routing-event.service';
import { loginConfig } from '../app-config/login-config';
import french from '../app-config/french';
import english from '../app-config/english';
import { IInput, LandingPageConfig } from '../app-model/config';
import { StorageService } from '../../services/storage.service';
import { SettingService } from '../../services/setting.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import 'base-frontend/build-dist/lib/auth-module/login/login-as-module';
import 'base-frontend/build-dist/lib/config-module/base-config';
import 'base-frontend-components/dist/src/loaders/lazy-loader';
import { PRODUCT_ID, USERROLE } from '../../util/constant';
import { CustomizationService } from '../../services/customization.service';
import { DataServices } from '../../services/data.service';
import { SUCCESS_CODE, UserCategoryEnum } from '../../shared/model/app';
import { Properties } from '../app-config/properties';
import { PageLoaderService } from 'src/shared/components/page-loader/page-loader.service';
import { HttpParams } from '@angular/common/http';
import { UserManagementService } from '../user-management/user.management.service';
import SnackBar from '../../shared/components/snackbar/snackbar';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  snackBar = new SnackBar();
  isForgotPassword: boolean = false;
  isSignIn: boolean = true;
  translation = {};
  loginInputs: Array<IInput> = loginConfig.fieldProperties;
  langingPageConfig: LandingPageConfig = {
    images: loginConfig.carouselImages,
    headers: loginConfig.carouselHeader,
    texts: loginConfig.carouselText,
  };
  socialButtons = loginConfig.social;
  loginButtonText = loginConfig.loginButtonText;
  returnUrl: string;
  productId = PRODUCT_ID;
  userSession: { sessionTimeOut: number; countDown: number } = {
    sessionTimeOut: 900,
    countDown: 60,
  };
  loginConfigData: any;
  countryImagesList: any;
  isAvaliable: boolean = false;
  showLazyloader: boolean = false;
  logo: string = `<svg xmlns="http://www.w3.org/2000/svg" width="124.06" height="58.692" viewBox="0 0 124.06 58.692"><defs><style>.a{fill:#06232c;font-size:28px;font-family:Muli-Bold, Muli;font-weight:700;}.b{fill:#4f8a45;stroke:#4f8a45;}.c{fill:#3375e7;stroke:#3374e6;}</style></defs><g transform="translate(0.711 0.711)"><g transform="translate(-51.651 -28)"><text class="a" transform="translate(113 69)"><tspan x="0" y="0">SRM</tspan></text></g><g transform="translate(3249.182 1672.426)"><path class="b" d="M-3245.175-1640.037l24.7-24.474,15.941,16.119,3.743-3.739-19.685-20.3-28.7,28.445Z" transform="translate(0 0)"/><path class="c" d="M-3237.326-1624.182l12.266-12.266,4.193,4.193-12.407,12.407Z" transform="translate(-3.872 -11.749)"/><path class="c" d="M-3225.577-1616.073l20.688-20.583,4.442,4.442-20.748,20.748Z" transform="translate(-7.708 -11.681)"/><path class="c" d="M-3213.257-1608.086l4.576,4.576,28.63-28.63-4.635-4.635Z" transform="translate(-11.731 -11.642)"/></g></g></svg>`;
  @ViewChild('baseConfigRef', { static: true }) baseConfig: any;
  @Input() allCategories;
  @Input() fetchCategories = false;
  logoUrl: any;

  image1: any = 'assets/home_image@2x.png';

  constructor(
    private routeEvent: RoutingEventService,
    private storageService: StorageService,
    private settingsService: SettingService,
    @Inject(DOCUMENT) private _document: Document,
    public translate: TranslateService,
    private customizationService: CustomizationService,
    public pageLoaderService: PageLoaderService,
    private dataService: DataServices,
    public userManagementService: UserManagementService,
    private route: Router,
    private store: StorageService
  ) { }

  async ngOnInit(): Promise<void> {
    // this.customizationService.setDefaultThemes();
    this.initializeConfig();
    // await this.getTheme();

    const authDetails = this.store.getUserAuthorizationDetails();
    if (authDetails) {
      // this.route.navigateByUrl('/dashboard');
    }
  }

  async getTheme() {
    // this.customizationService.getTheme().subscribe((res: any) => {
    //   if (res.code == SUCCESS_CODE) {
    //     this.store.setTheme(res.themeVals);
    //     Object.keys(res.themeVals).map((val) => {
    //       if (val == 'primary-color' || val == 'base-font') {
    //         document.documentElement.style.setProperty(
    //           `--${val}`,
    //           res.themeVals[val]
    //         );
    //         if (val == 'primary-color') {
    //           this.customizationService.setVariantPrimaryColors(
    //             res.themeVals[val]
    //           );
    //         }
    //       }
    //       if (val == 'favicon') {
    //         this._document
    //           .getElementById('appFavicon')
    //           ?.setAttribute(
    //             'href',
    //             'data:image/jpeg;base64,' + res.themeVals[val]
    //           );
    //       }
    //     });
    //     // this.headerImageUrl = this.store.getLogo();
    //   }
    // });
  }

  initializeConfig(): void {

    this.isAvaliable = true;

    this.langingPageConfig = {
      images: [
        'https://sfx-base-artifacts.s3.amazonaws.com/sideimage/sideimage1/sideimage1.png',
        'https://sfx-base-artifacts.s3.amazonaws.com/sideimage/sideimage2/sideimage2.png',
      ],
      headers: [{ key: "" }],
      texts: [{ key: "" }],
    };

    this.loginConfigData = {
      code: 0,
      productLogo: 'A base 64 image',
      google: {
        clientId:
          '685246269864-jfsbd1p6f772n8vfrtrv2pcitcuiqvo7.apps.googleusercontent.com',
      },
      carouselImages: [
        'https://sfx-base-artifacts.s3.amazonaws.com/sideimage/sideimage1/sideimage1.png',
        'https://sfx-base-artifacts.s3.amazonaws.com/sideimage/sideimage2/sideimage2.png',
      ],
      carouselHeader: [
        {
          key: 'baseAuthHeader1',
        },
        {
          key: 'baseAuthHeader2',
        },
      ],
      carouselText: [
        {
          key: 'baseAuthSubText1',
        },
        {
          key: 'baseAuthSubText2',
        },
      ],
      isDoubleFieldType: false,
      fieldProperties: [
        {
          type: 'text',
          label: {
            key: 'loginConfigEmailAddressLabelKey',
            defaultValue: 'Email Address',
          },
          placeholder: {
            key: 'loginConfigEmailAddressPlaceholderKey',
            defaultValue: 'Enter Email Address',
          },
          aria: 'email',
          name: 'email',
          subtype: 'email',
          minLength: 5,
          maxLength: 50,
          required: true,
          visibility: true,
          regexExpression:
            '^[a-zA-Z0-9.!#$%&’+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)$',
          regexMessage: {
            key: 'loginConfigEmailInvalidKey',
            defaultValue: 'Email not valid',
          },
          requiredMessage: {
            key: 'loginConfigEmailRequiredKey',
            defaultValue: 'Email is required',
          },
          minimumLengthMessage: {
            key: 'loginConfigEmailLengthKey',
            defaultValue: 'Email length too short, must be 5 characters and above',
          },
        },
        {
          type: 'text',
          label: {
            key: 'loginConfigPasswordLabelKey',
            defaultValue: 'Password',
          },
          placeholder: {
            key: 'loginConfigPasswordsPlaceholderKey',
            defaultValue: 'Enter Password',
          },
          aria: 'password',
          name: 'password',
          subtype: 'password',
          minLength: 5,
          maxLength: 50,
          required: true,
          visibility: true,
          requiredMessage: {
            key: 'loginConfigPasswordRequiredKey',
            defaultValue: 'Password is required',
          },
        },
      ],
      countriesList: [
        {
          name: 'Nigeria',
          code: '+234',
          image: 'https://cdn.countryflags.com/thumbs/nigeria/flag-400.png',
        },
        {
          name: 'Nicaragua',
          code: '+505',
          image:
            'https://cdn.webshopapp.com/shops/94414/files/54694016/nicaragua-flag-icon-free-download.jpg',
        },
        {
          name: 'Niger',
          code: '+227',
          image:
            'https://cdn.webshopapp.com/shops/94414/files/52409396/flag-of-niger.jpg',
        },
        {
          name: 'USA',
          code: '+001',
          image:
            'https://img.pngio.com/us-flag-images-for-usa-flag-clip-art-clipart-clipartix-usa-flag-usa-flag-png-hd-820_458.png',
        },
      ],
      loginButtonText: {
        key: '',
        defaultValue: 'Sign In',
      },
    }

    this.socialButtons = ['685246269864-jfsbd1p6f772n8vfrtrv2pcitcuiqvo7.apps.googleusercontent.com'];
    this.loginButtonText = { key: "", defaultValue: "Login" };

    // configure DOM tree
    setTimeout(() => {
      const baseLogin = document.getElementsByTagName("base-login-module")[0].shadowRoot.querySelector("base-login").shadowRoot.querySelector("div[class=\"container\"]");
      baseLogin.setAttribute("style", "font-size: 13px; font-family: Roboto !important; background-color: #00833a08 !important;");

      const baseLoginFormNavContainer = baseLogin.querySelector("form-top-nav").shadowRoot.querySelector("div");
      const baseLoginFormLangContainer = baseLoginFormNavContainer.querySelectorAll("div")[0];
      baseLoginFormLangContainer.setAttribute("style", "font-size: 12px; font-family: Roboto !important; margin-left: 15px;");

      const baseLoginFormSignUpContainer = baseLoginFormNavContainer.querySelectorAll("div")[1];
      baseLoginFormNavContainer.removeChild(baseLoginFormSignUpContainer);

      const baseLoginFormContainer = baseLogin.querySelector("div[class=\"form-container\"]");
      baseLoginFormContainer.setAttribute("style", "font-size: 13px; font-family: Roboto !important; max-width: 400px !important;");

      const baseLoginFormHeader = baseLoginFormContainer.querySelector("form-header").shadowRoot.querySelector("div");
      const baseLoginFormHeaderTitle = baseLoginFormHeader.querySelector("h2");
      baseLoginFormHeaderTitle.setAttribute("style", "font-size: 34px; font-family: Roboto !important;");
      baseLoginFormHeaderTitle.innerHTML = "Sign in";

      const baseLoginFormHeaderDescription = baseLoginFormHeader.querySelector("p");
      baseLoginFormHeaderDescription.setAttribute("style", "font-size: 13px; margin-top: .5rem; font-family: Roboto !important;");
      baseLoginFormHeaderDescription.innerHTML = "to continue to your account";

      const baseLoginFooterContainer = baseLogin.querySelector("footer-tag").shadowRoot.querySelector("footer");
      baseLoginFooterContainer.setAttribute("style", "font-size: 13px; font-family: Roboto !important; padding-left: 15px; padding-right: 15px;");

      const baseLoginFormForgotPassword = baseLoginFormContainer.querySelector("div[class=\"signup-link\"]");
      baseLoginFormContainer.removeChild(baseLoginFormForgotPassword);

      // 
      const baseLoginForm = baseLoginFormContainer.querySelector("base-login-form").shadowRoot.querySelector("form");

      // 
      let seamLoginForm = document.createElement("form");
      seamLoginForm.setAttribute("style", "font-size: 13px; font-family: Roboto !important;");
      seamLoginForm.setAttribute("method", "POST");
      seamLoginForm.setAttribute("action", "javascript:void(0);");
      baseLoginForm.parentNode.appendChild(seamLoginForm);
      baseLoginForm.childNodes.forEach((node: any) => {
        seamLoginForm.appendChild(node.cloneNode(true));
      });
      baseLoginForm.parentNode.removeChild(baseLoginForm);

      seamLoginForm = baseLoginFormContainer.querySelector("base-login-form").shadowRoot.querySelector("form");
      setTimeout(() => {

        const passwordFieldToggler: any = seamLoginForm.querySelector("span[class=\"password-icon\"]");
        passwordFieldToggler.addEventListener("click", (evt: any) => {
          const passwordField: any = seamLoginForm.querySelector("input[id=\"password\"]");
          if (passwordField.getAttribute("type").toString() === "password") {
            passwordField.setAttribute("type", "text");
          } else {
            passwordField.setAttribute("type", "password");
          }
        });

        const seamIdLoginFormSignInButton = seamLoginForm.querySelector("base-button").shadowRoot.querySelector("button");
        seamIdLoginFormSignInButton.addEventListener("click", (evt: any) => {
          const emailAddressField: any = seamLoginForm.querySelector("input[id=\"email\"]");
          emailAddressField.classList.remove("is-invalid");
          const emailAddressFieldErrorLabel: any = emailAddressField.parentElement.lastElementChild;
          emailAddressFieldErrorLabel.setAttribute("class", "display-none");

          const passwordField: any = seamLoginForm.querySelector("input[id=\"password\"]");
          passwordField.classList.remove("is-invalid");
          const passwordFieldErrorLabel: any = passwordField.parentElement.lastElementChild;
          passwordFieldErrorLabel.setAttribute("class", "display-none");

          if (emailAddressField.value.length <= 0) {
            emailAddressField.classList.add("is-invalid");
            emailAddressFieldErrorLabel.setAttribute("class", "invalid-feedback");

            // set field focus
            emailAddressField.focus();

            // 
            const emailFeedbackText = emailAddressFieldErrorLabel.querySelector("span[class=\"feedback-text\"]");
            emailFeedbackText.innerHTML = emailAddressField.placeholder;
            return;
          }
          else if (passwordField.value.length <= 0) {
            passwordField.classList.add("is-invalid");
            passwordFieldErrorLabel.setAttribute("class", "invalid-feedback");

            // set field focus
            passwordField.focus();

            // 
            const passwordFeedbackText = passwordFieldErrorLabel.querySelector("span[class=\"feedback-text\"]");
            passwordFeedbackText.innerHTML = passwordField.placeholder;
            return;
          } else {
            this.handleLoginAuthentication({
              username: emailAddressField.value,
              password: passwordField.value
            });
          }
        });

        const baseLoginFormSignInButtonSpan = seamLoginForm.querySelector("base-button").querySelector("span"); //.querySelector("span");
        baseLoginFormSignInButtonSpan.setAttribute("style", "font-size: 13px; font-family: Roboto !important; padding-left: 15px; padding-right: 15px;");
        baseLoginFormSignInButtonSpan.innerHTML = "Continue";
      }, 1000);

    }, 1000);

  }

  // 
  showError(error) {
    this.snackBar.create({
      text: error.description || error.message,
      duration: 7000,
      type: SnackbarType.DANGER,
    });
  }

  updateTranslation(filename: string): void {
    this.settingsService.getTranslation(filename).subscribe((result) => {
      if (result) {
        this.translation = result;
        this.baseConfig.nativeElement.mainAppJson(result);
      }
    });
  }

  async handleComponentRoute(detail): Promise<void> {
    let type = detail.detail.type;
    // if (type === LINKTYPES.DASHBOARD) {
    //   this.getUserSessionSettings();

    //   if (
    //     this.storageService.getProductUserCategoryName()?.toUpperCase() ===
    //     UserCategoryEnum.GUEST
    //   ) {
    //     this.routeEvent.goto(LINKTYPES.GUEST_VERIFICATION);
    //   } else {
    //     console.log(type);
    //     this.routeEvent.goto(type);
    //   }
    // } else {
    //   this.routeEvent.goto(type);
    // }



    const responseData: any = [];
    let bodyParameters = {
      username: "",
      password: ""
    };

    let paramKey = new HttpParams();

    this.pageLoaderService.show();
    await this.userManagementService
      .authenticateUserAccount(bodyParameters, paramKey)
      .subscribe((result) => {
        this.pageLoaderService.hide();
        if (result.code == 0) {
          const data = result.data;
        }
      }, (error) => {
        this.pageLoaderService.hide();
      });
  }

  async handleLoginAuthentication(detail): Promise<void> {
    this.pageLoaderService.show();
    await this.userManagementService
      .authenticateUserAccount(detail, (new HttpParams()))
      .subscribe((result) => {
        this.pageLoaderService.hide();
        if (result.success) {
          const data = result.data;
          if (data.isAuthenticated) {
            this.store.setUserAuthorizationDetails(data.details);
            switch (data?.details?.role) {
              case USERROLE.PRINTER:
                this.route.navigateByUrl('/dashboard/bulk-id-download');
                break;
              case USERROLE.USER:
                this.route.navigateByUrl(`/dashboard/id-management`);
                break;
              case USERROLE.ADMIN:
              default:
                this.route.navigateByUrl(`/dashboard/home`);
                break;
            }
          } else {
            this.showError({
              message: "Setup incomplete, please complete your registration."
            });
            if (result.code == '09') {
              this.route.navigateByUrl(`/setup/validate-link/${data?.details?.sessionId}`);
            } else {
              this.showError({
                message: "We’re having trouble signing you in. Please check your username and password and try again. If the problem persists, please contact admin for support."
              });
            }
          }
        } else {
          this.showError({
            message: "Oops! somthing went wrong, please try again later."
          });
        }
      }, (error) => {
        this.pageLoaderService.hide();
      });
  }

  getUserSessionSettings() {
    this.settingsService
      .getComponentSettings(this.productId, 'SESSION')
      .subscribe((res) => {
        const { code, settings } = res;
        if (code === 0) {
          settings.forEach((data) => {
            if (data.name === 'SESSION-TIME-OUT') {
              this.userSession.sessionTimeOut = +data.value;
            } else {
              this.userSession.countDown = +data.value;
            }
          });
        }
        this.storageService.setUserTimeOut(this.userSession);
        this.dataService.setUserIdleSession(this.userSession);
        let currentDay = new Date();
        let appTimeOutCheckStamp = currentDay.setSeconds(
          currentDay.getSeconds() + this.userSession.sessionTimeOut
        );
        this.storageService.setUserAllowedTimeStamp({
          allowedTime: appTimeOutCheckStamp,
        });
      });
  }

  languageChangeEvent(data): void {
    if (data.detail.language.toLowerCase() === 'french') {
      this.translation = french;
      this.translate.use('fr');
      //   this.updateTranslation('french-translation');
      this.baseConfig.nativeElement.mainAppJson(french);
    } else if (data.detail.language.toLowerCase() === 'english') {
      this.translation = english;
      this.translate.use('en');
      //   this.updateTranslation('english-translation');
      this.baseConfig.nativeElement.mainAppJson(english);
    }
  }

  loginConfig = {
    code: 0,
    productLogo: 'A base 64 image',
    social: [],
    carouselImages: [
      this.image1
    ],
    carouselHeader: [
      {
        key: 'baseAuthHeader1',
      },
      {
        key: 'baseAuthHeader2',
      },
    ],
    carouselText: [
      {
        key: 'baseAuthSubText1',
      },
      {
        key: 'baseAuthSubText2',
      },
    ],
    isDoubleFieldType: false,
    fieldProperties: [
      {
        type: 'text',
        label: {
          key: 'loginConfigEmailAddressLabelKey',
          defaultValue: 'Email Address',
        },
        placeholder: {
          key: 'loginConfigEmailAddressPlaceholderKey',
          defaultValue: 'Enter Email Address',
        },
        aria: 'email',
        name: 'email',
        subtype: 'email',
        minLength: 5,
        maxLength: 50,
        required: true,
        visibility: true,
        regexExpression:
          '^[a-zA-Z0-9.!#$%&’+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)$',
        regexMessage: {
          key: 'loginConfigEmailInvalidKey',
          defaultValue: 'Email not valid',
        },
        requiredMessage: {
          key: 'loginConfigEmailRequiredKey',
          defaultValue: 'Email is required',
        },
        minimumLengthMessage: {
          key: 'loginConfigEmailLengthKey',
          defaultValue:
            'Email length too short, must be 5 characters and above',
        },
      },
      {
        type: 'text',
        label: {
          key: 'loginConfigPasswordLabelKey',
          defaultValue: 'Password',
        },
        placeholder: {
          key: 'loginConfigPasswordsPlaceholderKey',
          defaultValue: 'Enter Password',
        },
        aria: 'password',
        name: 'password',
        subtype: 'password',
        minLength: 5,
        maxLength: 50,
        required: true,
        visibility: true,
        requiredMessage: {
          key: 'loginConfigPasswordRequiredKey',
          defaultValue: 'Password is required',
        },
      },
    ],
    countriesList: [
      {
        name: 'Nigeria',
        code: '+234',
        image: 'https://cdn.countryflags.com/thumbs/nigeria/flag-400.png',
      },
      {
        name: 'Nicaragua',
        code: '+505',
        image:
          'https://cdn.webshopapp.com/shops/94414/files/54694016/nicaragua-flag-icon-free-download.jpg',
      },
      {
        name: 'Niger',
        code: '+227',
        image:
          'https://cdn.webshopapp.com/shops/94414/files/52409396/flag-of-niger.jpg',
      },
      {
        name: 'USA',
        code: '+001',
        image:
          'https://img.pngio.com/us-flag-images-for-usa-flag-clip-art-clipart-clipartix-usa-flag-usa-flag-png-hd-820_458.png',
      },
    ],
    loginButtonText: {
      key: '',
      defaultValue: 'Sign In',
    },
  };
}
